<template>
  <v-container>
    <v-card v-if="selectedMsisdnClass">
      <v-card-title>
        Edit MSISDN Class
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-text-field
              v-model="msisdnClass.name"
              label="Name"
              :rules="[rules.required]"
          ></v-text-field>
          <v-text-field
              v-model.number="msisdnClass.msisdn_class_id"
              label="MSISDN Class ID (for import matching)"
              type="number"
              :rules="[rules.required]"
          ></v-text-field>
          <v-text-field
              v-model="msisdnClass.class_example"
              label="Class Example"
          ></v-text-field>
          <v-switch
              v-model="msisdnClass.active"
              :color="msisdnClass.active ? 'green' : 'red'"
              label="Active"
          ></v-switch>
          <v-text-field
              v-model.number="msisdnClass.count_busy"
              label="Count Busy"
              type="number"
          ></v-text-field>
          <v-text-field
              v-model.number="msisdnClass.count_available"
              label="Count Available"
              type="number"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="fetchUpdateMsisdnClass">Save</v-btn>
        <v-btn color="secondary" @click="resetForm">Reset</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { updateMsisdnClass } from "@/composables/useGetMsisdnsAPIs";

export default {
  props: {
    selectedMsisdnClass: {
      type: Object,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      msisdnClass:null,
      rules: {
        required: (value) => !!value || "This field is required",
      },
    };
  },
  methods: {
    async fetchUpdateMsisdnClass() {
      const result = await updateMsisdnClass(this.token, this.msisdnClass);
      if (result.error) {
        alert("Error updating MSISDN Class: " + result.message);
      } else {
        alert("MSISDN Class updated successfully!");
        this.$emit("MsisdnClassSavedEvent", result);
      }
    },
    resetForm() {
      this.$emit("reset-form");
    },
  },
  created() {
    this.msisdnClass=this.selectedMsisdnClass
  }
};
</script>
